import React from "react"; // 👈 add this at the top

export const CoinstoreImageColoumnFomatter = (cell, row, rowIndex, formatExtraData) => {
    let fileName = null;

    console.log("🔎 Row Data:", row);

    // Case 1: Direct string inside row.image
    if (typeof row.image === "string" && row.image.trim() !== "") {
        console.log("✅ Using row.image:", row.image);
        fileName = row.image.includes("amazonaws.com")
            ? row.image.substring(row.image.lastIndexOf("/") + 1)
            : row.image;
    }

    // Case 2: image object { default }
    else if (row?.image?.default) {
        console.log("✅ Using row.image.default:", row.image.default);
        fileName = row.image.default;
    }

    // Case 3: avatar.img.default
    else if (row?.avatar?.img?.default) {
        console.log("✅ Using row.avatar.img.default:", row.avatar.img.default);
        fileName = row.avatar.img.default;
    }

    // ✅ Build final URL if valid
    if (fileName && fileName !== "undefined") {
        const imgUrl = `https://storage.googleapis.com/gamerji-uploads/${fileName}`;
        console.log("🎯 Final Image URL:", imgUrl);
        return (
            <img
                src={imgUrl}
                className="max-h-70px"
                alt={row?.avatar?.name || row?.name || "product"}
            />
        );
    }

    console.warn("⚠️ No valid image found for row:", row._id);
    return "-";
};
